import useSession from 'components/auth/useSession'
import { PageLoading } from 'components/loading'
import React from 'react'

import { PrivateRootView } from './PrivateRootView'
import { PublicRootView } from './PublicRootView'
import SessionKeeper from './SessionKeeper'
import { SessionMultitabListener } from './SessionMultitabListener'

export function AuthPortal() {
  const { data, loading } = useSession()

  if (!data && loading) {
    return <PageLoading message='Carregando' />
  }

  return (
    <>
      <SessionMultitabListener />

      {data ? <PrivateRootWrapper /> : <PublicRootView />}
    </>
  )
}

const PrivateRootWrapper = () => (
  <>
    <SessionKeeper />
    <PrivateRootView />
  </>
)
